(() => {
  if (window.__raNewProductBadgeV3) return;
  window.__raNewProductBadgeV3 = true;

  const BADGE_COLLECTION_ID = '260636213439';
  let scheduled = false;

  const getNewProductIds = () => {
    const ids = new Set();
    document.querySelectorAll('script#label-product-metafields-info').forEach((script) => {
      try {
        const data = JSON.parse(script.textContent || '{}');
        const collections = Array.isArray(data.collections) ? data.collections.map(String) : [];
        if (collections.includes(BADGE_COLLECTION_ID) && data.id) ids.add(String(data.id));
      } catch (e) {}
    });
    return ids;
  };

  const updateBadges = () => {
    scheduled = false;
    const newProductIds = getNewProductIds();

    document.querySelectorAll('.m-product-card[data-product-id]').forEach((card) => {
      const productId = String(card.dataset.productId || '');
      const isNew = newProductIds.has(productId);
      const media = card.querySelector('.m-product-card__media');
      if (!media) return;

      card.querySelectorAll('.ra-card-new-badge').forEach((badge) => {
        if (badge.parentElement !== media) badge.remove();
      });

      let badge = media.querySelector(':scope > .ra-card-new-badge');

      if (!isNew) {
        if (badge) badge.remove();
        return;
      }

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ra-card-new-badge';
        badge.setAttribute('aria-label', 'Appena caricato');
        media.appendChild(badge);
      }

      badge.innerHTML = '<span class="ra-card-new-badge__star" aria-hidden="true">★</span><span>APPENA CARICATO</span>';
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateBadges);
  };

  const start = () => {
    schedule();
    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) =>
          node.nodeType === 1 && (
            node.matches?.('.m-product-card, script#label-product-metafields-info') ||
            node.querySelector?.('.m-product-card, script#label-product-metafields-info')
          )
        )
      );
      if (relevant) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', schedule);
})();